<div *ngIf="user.enableSIPExtension && isPhoneConnected">
    <div>
        <div class="flex inbound-call-box gap-2 align-items-center mb-4" *ngFor="let call of calls">
            <img src="/assets/images/no-user-image.png" class="caller-image" />
            <div class="extension-number flex-grow-1">{{ call.remoteIdentity.displayName }}</div>
            <p-button (click)="answer(call)" label="Descolgar" icon="pi pi-phone" severity="success"></p-button>
            <p-button (click)="hangup(call)" icon="pi pi-ban" severity="danger"></p-button>
        </div>
    </div>
    <p-tabView styleClass="p-tabview-panels-no-padding" (onChange)="onTabChange($event)" [(activeIndex)]="activeIndex">
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="pi pi-phone"></i>
                <span class="ml-2">Teléfono</span>
            </ng-template>

            <div class="m-4 flex flex-column">
                <div>
                    <input type="text" pInputText [(ngModel)]="phoneNumber" class="w-full phone-number-input" />
                </div>
                <div class="w-full flex flex-wrap phone-pad">
                    <div class="phone-pad-button">
                        <p-button (click)="clickNumber('1')">1</p-button>
                    </div>
                    <div class="phone-pad-button">
                        <p-button (click)="clickNumber('2')">2</p-button>
                    </div>
                    <div class="phone-pad-button">
                        <p-button (click)="clickNumber('3')">3</p-button>
                    </div>
                    <div class="phone-pad-button">
                        <p-button (click)="clickNumber('4')">4</p-button>
                    </div>
                    <div class="phone-pad-button">
                        <p-button (click)="clickNumber('5')">5</p-button>
                    </div>
                    <div class="phone-pad-button">
                        <p-button (click)="clickNumber('6')">6</p-button>
                    </div>
                    <div class="phone-pad-button">
                        <p-button (click)="clickNumber('7')">7</p-button>
                    </div>
                    <div class="phone-pad-button">
                        <p-button (click)="clickNumber('8')">8</p-button>
                    </div>
                    <div class="phone-pad-button">
                        <p-button (click)="clickNumber('9')">9</p-button>
                    </div>
                    <div class="phone-pad-button">
                        <p-button (click)="clickNumber('*')">*</p-button>
                    </div>
                    <div class="phone-pad-button">
                        <p-button (click)="clickNumber('0')">0</p-button>
                    </div>
                    <div class="phone-pad-button">
                        <p-button (click)="clickNumber('#')">#</p-button>
                    </div>
                </div>
                <div class="mt-4">
                    <p-button (click)="call()" label="Llamar" styleClass="w-full phone-call-button" severity="success" [disabled]="phoneNumber.length==0"></p-button>
                </div>
            </div>
        </p-tabPanel>
        
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="pi pi-users"></i>
                <span class="ml-2">Operarios</span>
            </ng-template>
            <div class="m-4 flex flex-column">
                <div>
                    <input type="text" placeholder="Buscar operario..." [(ngModel)]="workerName" pInputText (input)="loadWorkers()" class="w-full" />
                </div>
                <div *ngFor="let call of workers" class="call flex align-items-center gap-2">
                    <div class="call-icon">
                        <i class="pi pi-phone"></i>
                    </div>
                    <div class="flex-grow-1 flex flex-column">
                        <div class="flex">
                            <a *ngIf="call.phone1" (click)="loadPhonecall(call.phone1)">{{call.phone1}}</a>
                            <span *ngIf="call.phone1 && call.phone2">&nbsp;-&nbsp;</span>
                            <a *ngIf="call.phone2" (click)="loadPhonecall(call.phone2)">{{call.phone2}}</a>
                        </div>
                        <div>
                            {{call.name}}
                        </div>
                    </div>
                </div>
                <div *ngIf="totalWorkers>workers.length" class="call align-items-center" style="text-align: center"><small>...Filtrar por nombre para ver más...</small></div>
            </div>
        </p-tabPanel>
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="pi pi-history"></i>
                <span class="ml-2">Histórico</span>
                <span class="bullet" *ngIf="missedCalls.length>0">{{missedCalls.length}}</span>
            </ng-template>

            <div *ngFor="let call of historyCalls" class="call flex align-items-center gap-2">
                <div *ngIf="call.direction=='In'" class="call-icon">
                    <i class="pi pi-phone"></i>
                    <i class="pi pi-arrow-down-left top-icon top-icon-red"></i>
                </div>
                <div *ngIf="call.direction=='Out'" class="call-icon">
                    <i class="pi pi-phone"></i>
                    <i class="pi pi-arrow-up-right top-icon top-icon-green"></i>
                </div>
                <div *ngIf="call.direction=='Internal'" class="call-icon">
                    <i class="pi pi-phone"></i>
                    <i class="pi pi-arrows-h top-icon top-icon-blue"></i>
                </div>
                <div class="flex-grow-1 flex flex-column">
                    <a *ngIf="call.direction=='Out'" (click)="recall(call.dstNumber)">{{call.dstNumber}}</a>
                    <a *ngIf="call.direction=='In'" (click)="recall(call.srcNumber)">{{call.srcNumber}}</a>
                    <a *ngIf="call.direction=='Internal'" (click)="recall(internalPeer(call))">{{internalPeer(call)}}</a>
                    <div>
                        <small>{{call.start | date:'dd/MM/yyyy HH:mm:ss'}}. Duración {{call.totalDurationSec}} segundos</small>
                    </div>
                </div>
            </div>
        </p-tabPanel>
    </p-tabView>
</div>

<div *ngIf="!user.enableSIPExtension" class="m-4">
    <p-messages severity="info">
        <ng-template pTemplate>
            Tu usuario no tiene activada la extensión telefónica.<br>
        Contacta con el administrador si necesitas activarla.
        </ng-template>
    </p-messages>
</div>

<div *ngIf="user.enableSIPExtension && !isPhoneConnected" class="m-4">
    <p-messages severity="warn">
        <ng-template pTemplate>
            Tu extensión telefónica no está conectada.<br>
            Por favor que tu softphone esté abierto y conectado.
        </ng-template>
    </p-messages>
</div>